import * as Yup from 'yup';
import moment, { duration } from 'moment';
import { routeShape } from './Shapes';

function equalTo(ref: any, msg: string) {
    return this.test({
        name: 'equalTo',
        exclusive: false,
        message: msg || `${ref.path} must be the same as ${ref.reference}`,
        params: {
            reference: ref.path
        },
        test: function (value) {
            return value === this.resolve(ref)
        }
    })
};

declare module 'yup' {
    interface StringSchema {
        equalTo: (ref: Yup.Ref | string, msg?: string) => StringSchema;
    }
}

Yup.addMethod(Yup.string, 'equalTo', equalTo);

const resetPasswordShape = {
    password: Yup.string().required('Password is required').min(6, "Password must be at least 6 characters long"),
    checkPassword: Yup.string().equalTo(Yup.ref('password')),
}
const phoneRegExp = /^[0-9+\- ][0-9- ]*$/


const resetMyPasswordShape = {
    originalPassword: Yup.string().required('Original Password is required'),
    password: Yup.string().required('Password is required').min(6, "Password must be at least 6 characters long"),
    checkPassword: Yup.string().equalTo(Yup.ref('password')),
}

const allowedActionsShape = {
    entityType: Yup.string().required('Entity Type is required'),
    allowedRole: Yup.string().required('Role is required'),
    entityState: Yup.string().required('State is required'),
    nextState: Yup.string().required('Next is required'),
    actionName: Yup.string().required('Name is required'),
    actionType: Yup.string().required(),
    actionDescription: Yup.string(),
    condition: Yup.string()
}
let allowedActionsShapeYup = () => Yup.object().shape(allowedActionsShape);
const clientStaffShape = {
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().email('Email looks a bit strange...'),
    phoneNumber: Yup.string().required("Phone number is required").matches(phoneRegExp, 'Phone number is not valid'),
}
const adminShape = {
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().email('Email looks a bit strange...'),
}
const adminClientStaffShape = {
    canViewSupplierInfo: Yup.boolean(),
}

const newEmailShape = {

    newEmail: Yup.string().email('Email looks a bit strange...'),
}

let clientStaffShapeYup = () => Yup.object().shape({ ...clientStaffShape, ...adminClientStaffShape });
let adminShapeYup = () => Yup.object().shape({ ...adminShape });
let resetPasswordShapeYup = () => Yup.object().shape(resetPasswordShape);
let resetMyPasswordShapeYup = () => Yup.object().shape(resetMyPasswordShape);
let newEmailShapeYup = () => Yup.object().shape(newEmailShape);

const clientDepartmentShape = {
    clientMasterId: Yup.string().required("Parent Client is required."),
    firstName: Yup.string().required('First Name is required.'),
    lastName: Yup.string().required('Last Name is required.'),
    departmentPhone: Yup.string().required('Department  Phone is required.').matches(phoneRegExp, 'Phone number is not valid'),

    email: Yup.string().email().required('Email is required.'),
    notesForSupplier: Yup.string(),
    emailDomain: Yup.string(),

}
const adminClientDepartmentShape = {
    canViewSupplierInfo: Yup.boolean(),
    hidePrice: Yup.boolean(),
}

let clientDepartmentShapeYup = () => Yup.object().shape({ ...clientDepartmentShape, ...adminClientDepartmentShape });
const clientShape = {
    companyName: Yup.string().required('Company Name is required.'),
    companyAddress: Yup.string().required('Company Address is required.'),
    companyPhone: Yup.string().required('Company  Phone is required.').matches(phoneRegExp, 'Phone number is not valid'),
    firstName: Yup.string().required('First Name is required.'),
    lastName: Yup.string().required('Last Name is required.'),
    email: Yup.string().email().required('Email is required.'),
    notesForSupplier: Yup.string(),

}
let inviteClientStaffShapeYup = () => Yup.object().shape({ ...clientStaffShape, ...resetPasswordShape });
let inviteClientDepartmentShapeYup = () => Yup.object().shape({ ...clientDepartmentShape, ...resetPasswordShape });
let inviteClientShapeYup = () => Yup.object().shape({ ...clientShape, ...resetPasswordShape });
let inviteSupplierShapeYup = () => Yup.object().shape({ ...supplierShape, ...resetPasswordShape });
let inviteAdminShapeYup = () => Yup.object().shape({ ...adminShape, ...resetPasswordShape })
let inviteCharterAdminShapeYup = () => Yup.object().shape({ ...clientShape, ...resetPasswordShape });

const adminClientShape = {
    emailDomain: Yup.string(),
    canViewSupplierInfo: Yup.boolean(),
    hidePrice: Yup.boolean(),
    clientType: Yup.string().required('Client Type is required.'),
}

let clientShapeYup = () => Yup.object().shape({ ...clientShape, ...adminClientShape });
const supplierShape = {
    companyName: Yup.string().required('Company Name is required.'),
    companyAddress: Yup.string().required('Company Address is required.'),
    companyPhone: Yup.string().required('Company Phone is required.').matches(phoneRegExp, 'Phone number is not valid'),
    firstName: Yup.string().required('First Name is required.'),
    lastName: Yup.string().required('Last Name is required.'),
    email: Yup.string().email().required('Email is required.'),
    clientTypes: Yup.string().required('Client Type is required'),
    charterTypes: Yup.string().required('Charter Types is required.'),
};
const adminSupplierShape = {
    directDebit: Yup.string(),
    billingDueDate: Yup.string(),
    confirmedDate: Yup.string(),
    preferred: Yup.string(),

}

let supplierShapeYup = () => Yup.object().shape({ ...supplierShape, ...adminSupplierShape });

const indicativePriceShape = {
    from: Yup.string().required("From is required"),
    to: Yup.string().required("To is required"),
    preferredAircraft: Yup.array().required("Preferred Aircraft required"),
}

const emailIndicativeShape = {
    email: Yup.string().email('Email looks a bit strange...').required("Email is reuquired"),
    ...indicativePriceShape,
}


let indicativePriceShapeYup = () => Yup.object().shape(indicativePriceShape);
let emailIndicativeShapeYup = () => Yup.object().shape(emailIndicativeShape);

const manifestShape = {
    passengerName: Yup.string().required('Passenger name required'),
    contactNumber: Yup.string().matches(phoneRegExp, 'Contact number is not valid'),
    emailAddress: Yup.string().email('Email looks a bit strange...'),
    passengerWeight: Yup.number().required("Passenger weight required").positive("Passenger weight required"),
    freightWeight: Yup.number().typeError("Freight Weight must be a number"),
    cargoWeight: Yup.number().typeError("Cargo Weight must be a number"),
};

let manifestShapeYup = Yup.object().shape(manifestShape);

const createRouteShape = {
    viewDepartDate: Yup.date().transform(function (castValue, originalValue) {
        return Number.isNaN(originalValue) ? castValue : new Date(originalValue)
    }).required("Depart Date is required"),
    viewDepartTime: Yup.date().required("Depart Time is required"),
    from: Yup.string().required("From is required"),
    to: Yup.string().required("To is required"),
    passengerNumber: Yup.number(),
    passengerRange: Yup.boolean(),
    passengerRange_Max: Yup.number(),
    passengerRange_Min: Yup.number(),
    payload: Yup.number().moreThan(-1, "Please supply available payload"),
    manifest: Yup.array().of(
        Yup.object().shape(manifestShape))

};
let createRouteShapeYup = Yup.object().shape(createRouteShape);

const charterRequestShape = {
    purchaseOrderNumber: Yup.string(),
    jobReference: Yup.string(),
    catering: Yup.string().required(),
    charterSubType: Yup.string().required(),
    charterType: Yup.string().required(),
    clientId: Yup.string().required(),
    dangerousGoods: Yup.boolean().required(),
    dangerousGoodsIds: Yup.string(),
    preferredAircraft: Yup.string(),
    shared: Yup.boolean().required(),
    specialRequests: Yup.string(),
    routes: Yup.array().of(
        Yup.object().shape(createRouteShape)).required("Must have route")

};
const manifestItemShape = {
    manifest: Yup.array().of(
        Yup.object().shape(manifestShape))
}
const charterRequestManifestShape = {
    routes: Yup.array().of(
        Yup.object().shape(manifestItemShape)).required("Must have route")

};

let charterRequestManifestShapeYup = Yup.object().shape(charterRequestManifestShape);


const createCharterRequestShape = {
    biddingTimeSpanHours: Yup.number().required().positive().integer(),
    ...charterRequestShape,
}


const aircraftShape = {
    id: Yup.string(),
    aircraftCategoryId: Yup.string(),
    licenseNumber: Yup.string(),
    type: Yup.string(),
    passengerLimit: Yup.string(),
    aircraftNotes: Yup.string()

};


let aircraftShapeYup = Yup.object().shape(aircraftShape);

const aircraftImageShape = {
    supplierId: Yup.string().required(),

    category: Yup.string().required(),
    fileName: Yup.string().required(),
    file: Yup.string().required(),
    contentType: Yup.string(),
};
let aircraftImageShapeYup = Yup.object().shape(aircraftImageShape);

const placeBidRoute = {
    viewDepartDate: Yup.date().typeError("Invalid Date supplied").required("Depart Date is required"),
    viewDepartTime: Yup.date().typeError("Invalid Date supplied").required("Depart Time is required"),
    flightTime: Yup.string().required("Flight Time is required"),
    payload: Yup.number().required("Please supply available payload").moreThan(0, "Flight must support some payload"),
    passengerLimit: Yup.number().moreThan(0, 'Passenger limit is required'),
    aircraft: Yup.array().min(1, "At least one Aircraft required").required("Must select at least one aircraft"),
};

let createCharterRequestYup = Yup.object().shape(createCharterRequestShape);
let charterRequestYup = Yup.object().shape(charterRequestShape);

const placeBidShape = {
    bidderId: Yup.string().required("Supplier is required"),
    inclusions: Yup.string(),
    exclusions: Yup.string(),
    notes: Yup.string(),
    flightTimes: Yup.string(),
    status: Yup.string().required(),
    currency: Yup.string().required("Please supply a currency"),
    price: Yup.number().positive("Price is required. You don't want to do this for free, do you?"),
    routes: Yup.array().of(
        Yup.object().shape({
            ...placeBidRoute,
            parent: Yup.ref('routes'),
            flightTime: Yup.string().required().test("nonoverlapping", "You have overlapping flight times", (value, context) => {
                const i = parseInt(/(\[)(\d+)(?=\])/.exec(context.path)?.[2] ?? "0");
                const list = ((context as any).from[1].value as { routes: { flightTime: string, viewDepartDate: Date }[] }).routes;
                if (i >= list.length - 1) return true;
                const timeGap = moment.duration(moment(list[i + 1].viewDepartDate).diff(list[i].viewDepartDate));
                const [hours, minutes] = (list[i].flightTime ?? "00:00").split(':');
                const flightDuration = duration(parseInt(hours), "hours").add(minutes, "minutes");
                return timeGap.asMinutes() >= flightDuration.asMinutes();
            }).required("Flight time is a required field")
        })).required("Must have route")
}
let placeBidShapeYup = Yup.object().shape(placeBidShape);


export {
    charterRequestYup, indicativePriceShapeYup as indicitavePriceShapeYup, emailIndicativeShapeYup as emailIndicitaveShapeYup, manifestShapeYup, resetMyPasswordShapeYup,
    createCharterRequestYup, createRouteShapeYup, supplierShapeYup, clientShapeYup, adminShapeYup, charterRequestManifestShapeYup,
    clientDepartmentShapeYup, clientStaffShapeYup, allowedActionsShapeYup, newEmailShapeYup,
    placeBidShapeYup, aircraftShapeYup, resetPasswordShapeYup, aircraftImageShapeYup, inviteCharterAdminShapeYup,
    inviteClientDepartmentShapeYup, inviteClientShapeYup, inviteClientStaffShapeYup, inviteSupplierShapeYup, inviteAdminShapeYup
};